import { FormFieldTypes, ImageFormats, validationTypes } from "@repo/design-system/components/forms/libs";

export const buildProfilePhotoUploadConfig = () => ({
    name: "Profile Photo Upload",
    initialState: {
        profilePicture: ""
    },
    section: [
        {
            title: "",
            row: {},
            style: { sectionStyle: "" },
            rowGroup: [
                {
                    groupLabel: "",
                    style: { groupStyle: "" },
                    fields: [
                        {
                            id: "profilePicture",
                            label: "",
                            Field_Name: "Profile Picture",
                            fieldType: FormFieldTypes?.IMAGE ?? 13,
                            dataField: "profilePicture",
                            fieldSetting: {
                                placeholder: "Upload the profile picture",
                                allowMultipleImage: false,
                                isCircularPreview: true,
                                acceptedImageFormats: [
                                    ImageFormats?.JPEG ?? ".jpeg",
                                    ImageFormats?.JPG ?? ".jpg",
                                    ImageFormats?.PNG ?? ".png"
                                ],
                                minImageSizeInMB: 0,
                                maxImageSizeInMB: 5,
                                isDownloadable: false,
                            },
                            validation: [
                                { type: validationTypes?.REQUIRE ?? "require" },
                                { type: validationTypes?.IMAGE ?? "image" }
                            ],
                            style: {
                                containerCss: "col-md-12"
                            }
                        }
                    ]
                }
            ]
        }
    ]
});

export const ProfilePhotoUploadConfig = buildProfilePhotoUploadConfig();
